(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define(
      'announcement-bar',
      class AnnouncementBar extends HTMLElement {
        constructor() {
          super();
          this.resizeObserver = null;
        }

        connectedCallback() {
          this.updateHeight();
          this.resizeObserver = new ResizeObserver(() => this.updateHeight());
          this.resizeObserver.observe(this);
        }

        disconnectedCallback() {
          if (this.resizeObserver) {
            this.resizeObserver.disconnect();
          }
        }

        updateHeight() {
          const height = this.offsetHeight;
          document.body.style.setProperty('--announcement-bar-height', `${height}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SHADOW_STYLE_ID = 'contact-form-shadow-theme';
    const SHADOW_STYLES = `
      section {
        min-width: 98% !important;
      }

      button[type='submit'] {
        border-radius: 4rem !important;
      }
    `;

    const applyEmbedStyles = (embed) => {
      const shadowRoot = embed?.shadowRoot;
      if (!shadowRoot || shadowRoot.getElementById(SHADOW_STYLE_ID)) return;

      const style = document.createElement('style');
      style.id = SHADOW_STYLE_ID;
      style.textContent = SHADOW_STYLES;
      shadowRoot.appendChild(style);
    };

    const applySectionEmbedStyles = (section) => {
      section.querySelectorAll('shopify-forms-embed').forEach((embed) => applyEmbedStyles(embed));
    };

    const initContactEmbedShadowStyling = () => {
      const sections = document.querySelectorAll('.contact-form-section');
      if (!sections.length) return;

      sections.forEach((section) => {
        applySectionEmbedStyles(section);

        const observer = new MutationObserver(() => {
          applySectionEmbedStyles(section);
        });

        observer.observe(section, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initContactEmbedShadowStyling);
      return;
    }

    initContactEmbedShadowStyling();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-the-look')) {
    customElements.define(
      'shop-the-look',
      class ShopTheLook extends HTMLElement {
        constructor() {
          super();

          this.addToBag = this.querySelector('.js-add-to-bag');
          this.footerActions = this.querySelector('[data-shop-the-look-actions]');
          this.viewBagButton = this.querySelector('.js-view-bag');
          this.goToCheckoutButton = this.querySelector('.js-go-to-checkout');
          this.productAdds = this.querySelectorAll('add-to-cart');
          this.drawer = this.closest('side-drawer');

          this.productAdds.forEach((addToCart) => {
            addToCart.addEventListener('change', () => {
              const value = addToCart.getAttribute('data-variant-id');
              this.updateProducts();
            });
          });

          this.addToBag.addEventListener('click', (e) => {
            e.preventDefault();
            this.addProductsToCart();
          });
        }

        formatCountLabel(label, count) {
          return label.replace(/\{\{\s*amount\s*\}\}/g, count);
        }

        updateProducts() {
          const allSelected = Array.from(this.productAdds).filter((addToCart) => {
            return addToCart.getAttribute('data-variant-id') !== '' && !addToCart.classList.contains('disabled');
          });

          this.addToBag.disabled = !allSelected.length;
          if (allSelected.length > 1) {
            this.addToBag.textContent = this.formatCountLabel(window.cart.add_items, allSelected.length);
          } else {
            this.addToBag.textContent = this.formatCountLabel(window.cart.add_item, allSelected.length);
          }
        }

        async getCartItemCount() {
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`);
            if (!response.ok) return 0;

            const cart = await response.json();
            return cart.item_count || 0;
          } catch (error) {
            return 0;
          }
        }

        showPostAddActions(itemCount) {
          if (!this.addToBag || !this.footerActions || !this.viewBagButton) return;

          this.addToBag.classList.add('hidden');
          this.footerActions.classList.remove('hidden');
          this.viewBagButton.textContent = `View bag (${itemCount})`;
        }

        async addProductsToCart() {
          const variantIds = Array.from(this.productAdds)
            .map((addToCart) => {
              if (addToCart.getAttribute('data-variant-id') !== '' && !addToCart.classList.contains('disabled')) {
                return {
                  id: addToCart.getAttribute('data-variant-id'),
                  quantity: 1,
                };
              }
            })
            .filter((item) => item !== undefined);

          if (!variantIds.length) return;

          this.addToBag.classList.add('loading');

          try {
            await addToCart(variantIds, false);

            publish(PUB_SUB_EVENTS.cartUpdate);
            const itemCount = await this.getCartItemCount();
            this.showPostAddActions(itemCount);
          } finally {
            this.addToBag.classList.remove('loading');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
